<mat-toolbar class="tw-py-0 !tw-pr-0 tw-bg-transparent" style="background-color: transparent; color: white;" *ngIf="(visibleTabs$ | async) as plTabs">
  <span *ngFor="let tab of plTabs | slice:0:1" class="tw-px-3 h-full tw-inline-block">
    <ng-template [ngTemplateOutlet]="TabButton" [ngTemplateOutletContext]="{tab:tab}"></ng-template>
  </span>
  <span *ngFor="let tab of plTabs | slice:1:plTabs.length" class="tw-px-3 h-full tw-hidden 2xl:tw-inline-block">
    <ng-template [ngTemplateOutlet]="TabButton" [ngTemplateOutletContext]="{tab:tab}"></ng-template>
  </span>
  <span class="h-full tw-inline-block 2xl:tw-hidden tw-relative" *ngIf="plTabs.length > 2">
    <button data-cy="nav-more-tab" class="tw-px-3" [ngClass]="menuOpen ? 'tw-font-bold' : ''"
    mat-button [matMenuTriggerFor]="dropdownmenu" (menuOpened)="menuOpen=true;" (menuClosed)="menuOpen=false;">More&nbsp;
      <i class="fa fa-angle-down"></i>
    </button>
    <mat-menu #dropdownmenu="matMenu" xPosition="after">
        <div class="tw-py-3 tw-px-5 tw-text-white dropdown-menu-item"
        *ngFor="let tab of plTabs | slice:1:plTabs.length" (click)="onTabClick(tab)">{{tab.text}}
      </div>
    </mat-menu>
  </span>
</mat-toolbar>

<ng-template let-tab="tab" #TabButton>
  <button [color]="'primary'"
          [ngClass]="activeTab?.key === tab?.key ? 'current-tab' : ''"
          [attr.data-cy]="tab ? 'nav-'+tab?.key+'-tab': ''"
          [routerLink]="tab.uri">
    {{tab.text}}<div *ngIf='tab?.key === "tasks"'
    class="tw-ml-2 tw-text-sm tw-rounded-full tw-font-bold counter-circle tw-items-center tw-justify-center tw-inline-flex tw-text-center tw-p-3">
    {{ displayBadgeCount(( inboxBadgeCount$ | async)) }}
  </div>
  <div *ngIf='tab?.key === "today" && (todayBadgeCount$ | async)'
    class="tw-ml-2 tw-text-sm counter-pill {{requestsCount < 10 ? 'single-digit' : ''}}">
    {{ displayBadgeCount(( todayBadgeCount$ | async)) }}
  </div>
  </button>
</ng-template>
